import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1A73E8",
    },
  },
  typography: {
    fontFamily: "circular, Roboto, Helvetica, Arial, sans-serif",
  },
});

export default theme;
